import React from 'react';

export const TableTurnLogo = ({ size = "md", className = "" }) => {
  const sizes = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12"
  };

  return (
    <div className={`relative flex items-center justify-center ${sizes[size]} ${className}`}>
      {/* Base Plate / Command Grid */}
      <div className="absolute inset-0 bg-chefPanel rounded-lg rotate-3 opacity-20 border border-receiptWhite/10"></div>
      <div className="absolute inset-0 bg-chefDark border border-chefPanel rounded-md shadow-lg flex flex-wrap p-1 gap-0.5">
        {/* Heatmap Grid Representation */}
        <div className="w-[45%] h-[45%] rounded-[1px] bg-status-open/40"></div>
        <div className="w-[45%] h-[45%] rounded-[1px] bg-chiliRed animate-pulse"></div>
        <div className="w-[45%] h-[45%] rounded-[1px] bg-status-reserved/40"></div>
        <div className="w-[45%] h-[45%] rounded-[1px] bg-status-dirty/40"></div>
      </div>
      {/* Stylized 'T' Overlay */}
      <div className="relative z-10 font-mono font-black text-receiptWhite text-[1.2em] leading-none -mt-0.5">
        T
      </div>
    </div>
  );
};